var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_akar-circle-check",
    "data-name": "Icon akar-circle-check",
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.715,
    height: 86.715,
    viewBox: "0 0 86.715 86.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M83.715,43.358A40.358,40.358,0,1,1,43.358,3,40.358,40.358,0,0,1,83.715,43.358Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#c40000",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(31.095 31.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Core"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M24.526,2.453,22.073,0l-9.81,9.81L2.453,0,0,2.453l9.81,9.81L0,22.073l2.453,2.453,9.81-9.81,9.81,9.81,2.453-2.453-9.81-9.81Z",
    fill: "#c40000",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross-circle.9070ffcafd82344012387ce57f2eb183.svg";
export { ForwardRef as ReactComponent };